import { render, staticRenderFns } from "./AddDinner.vue?vue&type=template&id=7d57cc6a&scoped=true&"
import script from "./AddDinner.vue?vue&type=script&lang=js&"
export * from "./AddDinner.vue?vue&type=script&lang=js&"
import style0 from "./AddDinner.vue?vue&type=style&index=0&id=7d57cc6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d57cc6a",
  null
  
)

export default component.exports